"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Conditions = _interopRequireDefault(require("access-control-lib/conditions/Conditions"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _AccessControl = require("../constants/AccessControl");

var _selectors = require("settings-ui-sdk/Auth/selectors");

var _selectors2 = require("settings-ui-sdk/Routes/selectors");

var _UIRouterTab = _interopRequireDefault(require("ui-addon-react-router/UIRouterTab"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _Route = require("../constants/Route");

var _identity = _interopRequireDefault(require("transmute/identity"));

var TABS = null;

var getTabConfiguration = function getTabConfiguration() {
  if (!TABS) {
    TABS = [{
      accessControl: _AccessControl.READ,
      className: 'accountdefaults-tabs-generalInfo',
      id: 'general',
      to: _Route.ROUTE + "/general",
      title: _I18n.default.text('accountdefaults.tabs.generalInfo')
    }, {
      accessControl: _AccessControl.READ,
      className: 'accountdefaults-tabs-branding',
      id: 'branding',
      to: _Route.ROUTE + "/branding",
      title: _I18n.default.text('accountdefaults.tabs.branding')
    }, {
      accessControl: {
        and: [_AccessControl.READ, _AccessControl.MULTI_CURRENCY_GATE]
      },
      className: 'accountdefaults-tabs-multicurrency',
      id: 'multicurrency',
      to: _Route.ROUTE + "/multicurrency",
      title: _I18n.default.text('accountdefaults.tabs.multicurrency')
    }];
  }

  return TABS;
};

var TabsContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TabsContainer, _PureComponent);

  function TabsContainer() {
    (0, _classCallCheck2.default)(this, TabsContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TabsContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(TabsContainer, [{
    key: "getActiveTab",
    value: function getActiveTab() {
      var pathName = this.props.pathName;

      if (pathName.includes(_Route.ROUTE + "/general")) {
        return 'general';
      } else if (pathName.includes(_Route.ROUTE + "/branding")) {
        return 'branding';
      } else if (pathName.includes(_Route.ROUTE + "/multicurrency")) {
        return 'multicurrency';
      }

      return null;
    }
  }, {
    key: "renderTab",
    value: function renderTab(_ref) {
      var className = _ref.className,
          id = _ref.id,
          to = _ref.to,
          title = _ref.title;
      return _react.default.createElement(_UIRouterTab.default, {
        className: className,
        key: id,
        tabId: id,
        title: title,
        to: to
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          gates = _this$props.gates,
          isMultiCurrencyActive = _this$props.isMultiCurrencyActive,
          scopes = _this$props.scopes;
      var configurations = getTabConfiguration().filter(isMultiCurrencyActive ? _identity.default : function (_ref2) {
        var id = _ref2.id;
        return id !== 'multicurrency';
      }).filter(function (_ref3) {
        var accessControl = _ref3.accessControl;
        return _Conditions.default.shouldAccess(accessControl)({
          gates: gates,
          scopes: scopes
        });
      });
      var activeTab = this.getActiveTab();

      if (configurations.length > 1 || configurations.length === 1 && configurations[0].id !== activeTab) {
        return _react.default.createElement(_UITabs.default, {
          className: "accountdefaults-tabs",
          wrapperClassName: "m-bottom-4",
          defaultSelected: activeTab,
          use: "enclosed"
        }, configurations.map(this.renderTab));
      }

      return null;
    }
  }]);
  return TabsContainer;
}(_react.PureComponent);

TabsContainer.propTypes = {
  pathName: _react.PropTypes.string.isRequired,
  gates: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.object]).isRequired,
  isMultiCurrencyActive: _react.PropTypes.bool.isRequired,
  scopes: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.object]).isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    pathName: (0, _selectors2.getPathNameFromRouting)(state),
    isMultiCurrencyActive: state.multiCurrency.get('active'),
    gates: (0, _selectors.getUserGates)(state),
    scopes: (0, _selectors.getUserScopes)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(TabsContainer);

exports.default = _default;
module.exports = exports.default;